// @ts-strict-ignore
import {ParamComponent} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {SelectedPropertyItem} from 'common/query-builder/query-block/properties-menu/types';

import {template} from './template';
import css from './index.inline.styl';
import {ContextMenuJsxProps, ContextMenuParams, ContextMenuState} from './types';

const CONTEXT_MENU_DEFAULTS = {
  breakdown: {label: `Expand by property`, icon: `segment`},
  hide: {label: `Hide event`, icon: `eye-hide`},
};

export class ContextMenu extends ParamComponent<ContextMenuParams, ContextMenuState> {
  private declare domEl: HTMLElement;

  get config() {
    return {
      template,
      useShadowDom: true,
      params: {
        breakdownOptions: Object,
        menuItems: Array,
        open: Boolean,
        position: Object,
        projectId: Number,
        workspaceId: Number,
        breakdownEvent: String,
        relativePositioning: Boolean,
        positionParent: Object,
      },
      defaultState: {
        secondaryAction: null,
        positionParent: null,
      },
      helpers: {
        inserted: (vnode) => {
          if (!this.params.relativePositioning) {
            const anchor = (document.querySelector(`mp-browser-context-root`) as HTMLElement) || document.body;

            this.domEl = vnode.elm;
            anchor.style.position = `relative`;
            anchor.appendChild(this.domEl);
          }
        },
        getCss: () => css.toString(),
        handleBreakdownMenuSelect: (item: SelectedPropertyItem) => {
          this.dispatchEvent(
            new CustomEvent(`action`, {
              detail: {
                action: `breakdown`,
                value: item.item,
              },
            }),
          );
          this.reset();
        },
        handleContextMenuSelect: (ev) => {
          if (ev.detail.item.value === `breakdown`) {
            this.update({secondaryAction: `breakdown`});
          } else {
            this.dispatchEvent(new CustomEvent(`action`, {detail: {action: ev.detail.item.value}}));
            this.reset();
          }
        },
        handleDropMenuChange: (ev) => {
          if (ev.detail.state === `closed`) {
            this.dispatchEvent(new CustomEvent(`close`));
            this.reset();
          }
        },

        menuItems: () => {
          return this.params.menuItems.map((item) => ({...CONTEXT_MENU_DEFAULTS[item.value], ...item}));
        },
        breakdownDisabledItemsMap: () =>
          (this.params.breakdownOptions.disabledItems || []).reduce((map, item) => ({...map, [item]: true}), {}),
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.params.positionParent) {
      this.update({positionParent: this.params.positionParent});
    }
  }

  disconnectedCallback() {
    if (this.domEl) {
      this.domEl.remove();
    }
  }

  reset() {
    this.update(this.config.defaultState);
  }
}

export const ContextMenuEl = defineAndMakeJsxFactory<ContextMenuJsxProps>(`mp-context-menu`, ContextMenu);
export const ContextMenuReact = panel2react<ContextMenuJsxProps>(`mp-context-menu`, ContextMenu);
